{
  "meterMulti": {
    "analogCalibration": "針式の校正設定です。読取範囲や目盛の最小・最大値を変更する場合は、Godで再校正し、CPU画像テストで確認してください。",
    "x": "範囲の左端（画像幅を1とする比率）",
    "y": "範囲の上端（画像高さを1とする比率）",
    "w": "範囲の幅（画像幅を1とする比率）",
    "h": "範囲の高さ（画像高さを1とする比率）",
    "unfixedDecimal": "小数点位置を固定しない",
    "conditionExample": "例: 23より大きい、20以下",
    "refresh": "画像を再取得",
    "wholeImage": "画像全体（読取範囲付き）",
    "image": "読取対象の画像",
    "item": "読取項目 {{number}}",
    "label": "項目名",
    "roi": "画像で範囲を編集",
    "conditionReference": "閾値条件の対象項目です。削除する前に条件の対象を変更してください。",
    "remove": "項目を削除",
    "add": "読取項目を追加",
    "mode": "読取形式",
    "multi": "複数項目（単位なし）",
    "single": "従来の単一項目",
    "conditionField": "閾値条件の対象項目",
    "edit": "読取項目を編集"
  },
  "meterCreate": {
    "title": "メーター検知を追加",
    "create": "無効状態で作成",
    "camera": "対象カメラ",
    "name": "検知名",
    "unit": "単位",
    "width": "元画像の幅（px）",
    "height": "元画像の高さ（px）",
    "x": "読取範囲の左端（px）",
    "y": "読取範囲の上端（px）",
    "w": "読取範囲の幅（px）",
    "h": "読取範囲の高さ（px）",
    "digits": "数字の桁数（符号・小数点を除く）",
    "decimals": "小数点以下の桁数",
    "confidence": "最低信頼度（0〜1）",
    "minimum": "読取値の最小値",
    "maximum": "読取値の最大値",
    "stale": "画像の有効期間（秒）",
    "guidance": "1つの検知に、同じ画像から読む複数の項目を登録できます。通知は無効です。作成後、管理者がGodの対象カメラで検知を有効化し、画像テストで値を確認してから専用処理を再開してください。",
    "validation": "すべての項目を入力してください。範囲は元画像内、小数桁は数字の桁数未満、最小値は最大値以下に指定します。",
    "noCameras": "管理可能な対象カメラがありません。権限とカメラ設定を確認してください。",
    "error": "作成できませんでした。入力内容と権限を確認してください。"
  },
  "aiDetectionActionMenu": {
    "label": "データごと削除",
    "ariaLabel": "検知メニュー"
  },
  "aiDetectionCard": {
    "text": "最新結果",
    "text2": "詳細を見る",
    "text3": "{{value}} 検知",
    "text4": "読取結果は詳細で確認できます",
    "text5": "読取結果"
  },
  "aiDetectionDeleteDialog": {
    "title": "検知データ削除の確認",
    "text": "をデータごと削除しますか？",
    "text2": "削除すると、一覧と詳細のどちらからも参照できなくなります。"
  },
  "aiDetectionDetailPage": {
    "csvCameraLabel": "許可された対象カメラすべて",
    "label": "すべて",
    "label2": "未確認",
    "label3": "正検知",
    "label4": "誤検知",
    "usePageTitle": "AI検知イベント",
    "label5": "検知時刻",
    "label6": "カメラ",
    "label7": "結果",
    "enqueueSnackbar": "CSV出力の開始日時と終了日時を正しく設定してください。",
    "text": "対象外",
    "enqueueSnackbar3": "この検知イベントはレビューに対応していません",
    "enqueueSnackbar4": "レビューを表示する権限がありません",
    "enqueueSnackbar5": "レビューを保存しました",
    "enqueueSnackbar6": "参照できる検知画像がありません",
    "enqueueSnackbar7": "viewer を開くためのカメラ情報が取得できませんでした",
    "text2": "検知イベントを検索中... ({{value}}件確認済み)",
    "text3": "検知イベントの検索に失敗しました",
    "text4": "該当する検知イベントはありません",
    "text5": "検知結果を確認",
    "text6": "映像を確認",
    "text7": "エラーが発生しました",
    "alert": "このAI検知はエリア移動により停止済みです。設定変更・削除はできませんが、停止前の検知データを参照できます。",
    "label8": "開始日時",
    "label9": "終了日時",
    "placeholder": "カメラ名/検知結果で検索",
    "label10": "判定結果",
    "text8": "CSV出力中... ({{value}}件)",
    "text9": "CSVダウンロード",
    "label11": "誤検知を非表示",
    "imageAlt": "AI検知結果",
    "text10": "AI検知結果 {{previewEventDate}}",
    "text11": "修正履歴の取得に失敗しました",
    "text12": "追加の修正履歴を取得できませんでした",
    "text13": "レビューの最新状態を取得できませんでした",
    "error": "CSV出力の取得時間が5分を超えました。期間を短くして再度お試しください。CSVは出力していません。",
    "enqueueSnackbar8": "CSV出力を中断しました。CSVは出力していません。",
    "enqueueSnackbar9": "CSVダウンロードに失敗しました",
    "button": "CSV出力を中断",
    "text14": "期間制限なし",
    "text15": "最新順で最大{{value}}件を出力（期間制限なし）",
    "csvTruncatedNotice": "上限のため最新{{value}}件を出力しました。全件の出力ではありません。",
    "text16": "取得した範囲に読取結果はありません。続きの期間を取得できます。",
    "text17": "該当する読取結果はありません",
    "button2": "さらに読取結果を取得",
    "button3": "見逃し報告・画像修正",
    "backToList": "一覧へ戻る"
  },
  "aiDetectionEditorDialog": {
    "text": "{{seconds}}秒間隔",
    "text2": "{{value}}分間隔",
    "text3": "{{value}}時間間隔",
    "text4": "1日1回",
    "text5": "検知タイトルを入力してください",
    "text6": "検知タイトルは10文字以内で入力してください",
    "text7": "対象カメラを選択してください",
    "text8": "AI検知がONのカメラのみ選択できます",
    "text9": "検知対象を入力してください",
    "text10": "検知条件を入力してください",
    "text11": "検知条件数を入力してください",
    "text12": "検知条件数は1以上の数値を入力してください",
    "text13": "検知開始日時を入力してください",
    "text14": "検知終了日時を入力してください",
    "text15": "検知終了日時は検知開始日時以降を指定してください",
    "text16": "検知時間スケジュールを設定してください",
    "setErrorMessage": "対象カメラのエリア情報を解決できませんでした",
    "text17": "検知条件の保存に失敗しました",
    "text18": "カスタム検知",
    "text19": "定型検知",
    "label": "検知タイトル（10文字以内）",
    "label2": "検知の種類",
    "menuItem": "人数",
    "menuItem2": "ヘルメット未着用",
    "label3": "（人数のみ）検知条件数",
    "label4": "比較条件",
    "menuItem3": "以上",
    "menuItem4": "超",
    "text20": "対象カメラ",
    "text21": "カスタム",
    "text22": "定型",
    "text23": "の上限件数はカメラごとの設定に従います",
    "text24": "AI検知がONのカメラがありません",
    "label5": "{{name}}（{{value}}検知数{{usageCount}}/{{value2}}）",
    "label6": "検知範囲の指定",
    "menuItem5": "オフ",
    "menuItem6": "オン（Viewerで範囲指定）",
    "text25": "対象カメラを選択している場合のみ利用できます",
    "label7": "検知開始日時",
    "label8": "検知終了日時",
    "label9": "終了日なし",
    "label10": "検知時間",
    "menuItem7": "終日",
    "menuItem8": "時間帯を指定",
    "menuItem9": "スケジュールを指定",
    "label11": "検知開始時間帯",
    "label12": "検知終了時間帯",
    "button": "編集する",
    "label13": "通知メール送信先",
    "label14": "メモ",
    "text26": "検知頻度：",
    "text27": "（コピー時は変更できません）",
    "label15": "検知頻度",
    "text28": "検知頻度：5秒間隔",
    "button2": "実行",
    "text29": "カスタム",
    "text30": "定型"
  },
  "aiDetectionEventCard": {
    "text": "映像を確認",
    "text2": "AI検知結果画像を拡大",
    "text3": "結果なし",
    "text4": "レビュー",
    "text5": "履歴を見る"
  },
  "aiDetectionEventTable": {
    "text": "映像を確認",
    "label": "検知時刻",
    "label2": "検知結果",
    "text2": "結果なし",
    "label3": "レビュー状態",
    "text3": "対象外",
    "label4": "操作",
    "text4": "レビュー",
    "text5": "履歴を見る"
  },
  "aiDetectionListPage": {
    "label": "すべて",
    "label2": "カスタム",
    "label3": "全て",
    "label4": "検知中",
    "label5": "停止済",
    "enqueueSnackbar": "削除対象を取得できませんでした",
    "enqueueSnackbar2": "移動済みのAI検知履歴は削除できません",
    "enqueueSnackbar3": "{{value}}をデータごと削除しました",
    "text": "エラーが発生しました",
    "placeholder": "カメラ名/エリア名/検知名で検索",
    "button": "フィルタ",
    "label8": "検知種別",
    "label9": "エリア / カメラ"
  },
  "aiDetectionListTable": {
    "label": "最新結果",
    "label2": "検知設定",
    "label3": "種別",
    "label4": "状態",
    "label5": "最新検知時刻",
    "label6": "エリア/カメラ",
    "label7": "読取結果",
    "text": "読取結果は詳細で確認できます"
  },
  "aiDetectionNotificationDialog": {
    "setErrorMessage": "通知先の更新に失敗しました",
    "text": "通知先の変更",
    "text2": "の通知先メールアドレスを入力してください",
    "label": "通知メール送信先"
  },
  "aiDetectionReviewDialog": {
    "label": "未確認に戻す",
    "label2": "正検知にする",
    "label3": "誤検知にする",
    "text": "保存キーが別の更新で使用されています。内容を確認して再度保存してください。",
    "text2": "同じ項目が別の利用者により更新されました。最新状態を確認してから再度保存してください。",
    "text3": "レビューの保存に失敗しました。入力内容を保持したまま再試行できます。",
    "text4": "日時不明",
    "text5": "判定変更",
    "text6": "結果修正",
    "text7": "AI原文へ復帰",
    "text8": "判定・結果変更",
    "text9": "レビュー更新",
    "text10": "レビュー更新（{{action}}）",
    "text11": "保存中...",
    "title": "AI検知結果をレビュー",
    "alert": "検知イベントを一意に識別できないため、レビューを表示できません。",
    "alert2": "この検知結果はまだ人手レビューに対応していません。",
    "text12": "検知時刻",
    "alt": "レビュー対象の検知画像",
    "text13": "検知画像を表示できません",
    "text14": "検知画像はありません",
    "text15": "保存済みのレビュー状態",
    "alert3": "この検知結果は閲覧のみ可能です。判定・修正を行う権限がありません。",
    "text16": "最新状態を反映",
    "text17": "最新状態を反映して再試行",
    "text18": "競合項目:",
    "text19": "AIが生成した原文",
    "text20": "結果なし",
    "ariaLabel": "判定ステータス",
    "text21": "判定",
    "alert4": "誤検知として保存すると、この検知結果はViewer画面で非表示になります。Adminではフィルタから再表示できます。",
    "label4": "修正後の結果",
    "label5": "コメント（任意）",
    "text22": "修正履歴を閉じる",
    "text23": "修正履歴を見る",
    "ariaLabel2": "修正履歴を読み込み中",
    "text24": "修正履歴はありません",
    "text25": "実行者不明",
    "text26": "コメント:",
    "text27": "履歴を読み込み中...",
    "text28": "さらに読み込む",
    "button": "検知枠を編集"
  },
  "expandableResultText": {
    "text": "もっと見る"
  },
  "aiDetectionCsv": {
    "text5": "検知時刻",
    "text6": "未解析結果",
    "text7": "レビュー状態",
    "text8": "状態",
    "text9": "カメラ名",
    "text10": "検知結果",
    "text11": "観測時刻",
    "text12": "値",
    "text13": "単位",
    "text14": "OCR文字列",
    "text15": "信頼度",
    "text16": "検証結果",
    "text17": "拒否理由",
    "push": "\r\n{{value}}",
    "error": "CSV出力期間が不正です",
    "text18": "採用",
    "text19": "拒否"
  },
  "aiDetectionReview": {
    "text": "正検知",
    "text2": "誤検知",
    "text3": "未確認",
    "text4": "判定",
    "text5": "修正後の結果",
    "text6": "その他の変更",
    "text7": "その他（{{normalizedField}}）",
    "text8": "なし",
    "text9": "不明な判定（{{value}}）",
    "text10": "AI原文（修正なし）",
    "text11": "空文字",
    "errorMessage": "修正後の結果を入力してください"
  },
  "aiDetectionStopDialog": {
    "text": "停止中...",
    "text2": "停止",
    "title": "検知停止の確認",
    "text3": "を停止しますか？"
  },
  "aiDetectionWeeklyScheduleDialog": {
    "label": "確定",
    "title": "検知時間スケジュールを編集",
    "text": "ドラッグして時間帯を選択・解除できます",
    "label2": "{{label}}曜日 {{value}}-{{value2}}"
  },
  "meterEventConditionDialog": {
    "title": "メーターの検知条件",
    "loadError": "検知条件を取得できません",
    "loading": "読み込み中",
    "locked": "専用処理の稼働中は変更できません。管理者が専用処理を停止してから変更し、再検証・再開してください。",
    "saveError": "保存できませんでした。条件と権限を確認してください。",
    "guidance": "既存の数値読取に対して閾値を判定します。専用処理は停止後に変更し、管理者による再検証・再開が必要です。外部通知の設定は変更しません。",
    "saved": "検知条件を保存しました。再検証後に専用処理を再開してください。",
    "enabled": "閾値イベントを有効にする",
    "example": "例: 作業半径が25mを超えたら、温度が30℃以上。単位付きの比較を1つ入力してください。",
    "ongoing": "継続中の閾値イベントを保存・表示する",
    "ongoingHelp": "数値履歴は常に別途表示します。継続中は通知・シークバーの開始ピンを増やしません。",
    "compiled": "保存済みの比較: 読取値 {{operator}} {{threshold}}"
  },
  "meterResults": {
    "readings": "数値履歴",
    "events": "閾値イベント",
    "edit": "検知条件を編集"
  },
  "aiDetectionCsvExportControls": {
    "formattedDownload": "整形CSVダウンロード",
    "alert": "集約CSVの利用設定を確認できません。",
    "cameraLabel": "出力するカメラ",
    "button": "再確認",
    "button3": "生成履歴",
    "historyError": "CSVの生成状況を取得できません。",
    "historyTruncated": "直近100件にこのカメラの生成履歴がないため、上部の生成状況は不明です。",
    "running": "CSV生成中",
    "completed": "CSV生成完了",
    "failed": "CSV生成に失敗しました。途中のCSVはありません。",
    "summaryRows": "サマリー {{value}} 行",
    "summaryDownload": "サマリーCSVをダウンロード",
    "linkRetry": "ダウンロードリンクを再取得",
    "summaryUnavailable": "サマリーCSVは利用できません。生成履歴を確認してください。",
    "settingChanged": "公開設定が変更されました。カメラと公開版を再確認してください。",
    "createFailed": "CSV生成を受け付けられませんでした。再度お試しください。",
    "semanticNotice": "整形CSVには追加AI処理が含まれます。整形CSVダウンロードを押すと、費用見積上限 USD {{value}}・条件版 {{revision}} で生成します。"
  },
  "aiDetectionCsvExportDialog": {
    "unsupportedSource": "この入力データは未対応、または公開設定で許可されていません。GodでCSV出力設定を確認してください。",
    "text": "集約・解析CSVを生成",
    "alert": "現在のページだけでなく、以下の条件に一致する全件が対象です。行数を超えた場合は途中で切り捨てずエラーになります。受付後は画面を閉じても処理が続きます。",
    "text3": "対象の表示期間（終了分を含む）:",
    "text4": "開始分から終了分までを含みます。APIの終了境界は次の分の開始時刻（含まない）です。処理期間は最大31日です。APIの終了境界:",
    "text5": "出力タイムゾーン:",
    "text6": "対象カメラ:",
    "text7": "入力データ:",
    "text8": "検索:",
    "text9": "指定なし",
    "text10": "判定結果:",
    "text11": "状態:",
    "text12": "/ アーカイブ:",
    "text13": "含む",
    "text14": "含まない",
    "text15": "出力列:",
    "text16": "サマリー上限:",
    "text17": "行 / 入力上限:",
    "text18": "件 / 監査上限:",
    "text19": "行",
    "text20": "実行時に権限と公開版を再確認します。計算式の編集はGodで行います。",
    "alert2": "この設定はメーター観測一覧ではなく、状態変化を保存した検知イベントを使用します。5秒ごとの観測が揃う保証はありません。メーター観測のレビュー条件は引き継ぎません。",
    "button": "条件変更を確認して連続数値観測へ切り替える",
    "label": "対象データ・条件・公開版と上限を確認しました",
    "button2": "取消",
    "text21": "受付中…",
    "text22": "この条件で生成"
  },
  "aiDetectionCsvExportHistory": {
    "text": "集約・解析CSVの生成履歴",
    "text2": "この検知で、自分が「CSVダウンロード」から作成を依頼したCSVの履歴です。作成を依頼した時点の期間・条件・CSV出力設定で生成します。",
    "text3": "生成履歴を読み込み中…",
    "alert": "生成履歴を取得できませんでした。",
    "button": "再取得",
    "text4": "生成履歴はありません。",
    "text6": "受付",
    "text8": "期間",
    "text9": "（終了を含まない） /",
    "text10": "検索:",
    "text11": "指定なし",
    "text12": "/ カメラ:",
    "text13": "許可された対象カメラすべて",
    "cameraCount": "{{value}}台",
    "text14": "入力",
    "text15": "未確定",
    "text16": "件 → サマリー",
    "text17": "行 / 監査",
    "text18": "行",
    "text19": "保存期限:",
    "alert2": "生成できませんでした:",
    "alert3": "。途中のCSVは出力していません。",
    "text20": "サマリーCSV",
    "text21": "監査CSV",
    "text22": "実行情報JSON",
    "button2": "生成を中止",
    "button3": "再試行",
    "alert4": "ダウンロードに失敗しました:",
    "button4": "最新の履歴へ",
    "button5": "次の履歴",
    "text23": "同じ条件で再試行しますか？",
    "text24": "生成を中止しますか？",
    "text25": "同じ公開版・条件で再実行します。追加の処理費用が発生する場合があります。",
    "text26": "中止後は、この実行のCSVを取得できません。すでに完了した場合は結果を再確認してください。",
    "text27": "このジョブに固定された費用条件を使用します。現在の公開設定へは切り替えません。",
    "text28": "費用を確認して再試行",
    "text29": "生成を中止する"
  },
  "csvSemanticCostConfirmation": {
    "alert": "この出力にはAIによる分類・抽出が含まれ、通常の計算とは別に処理費用が発生します。上限超過時は処理を中止します。",
    "text": "追加AI処理の見積上限: USD",
    "text2": "/ 費用条件の版:",
    "label": "追加AI処理の費用上限と条件の版を確認しました"
  },
  "csvExportPresentation": {
    "emptySummary": "入力記録はありますが、この期間に集約条件を満たす結果がなく、サマリーは0行です。監査CSVで記録と判定経過を確認してください。",
    "noData": "指定期間に入力記録がありません。日時と対象カメラを確認してください。",
    "legacySparse": "元データの観測間隔を確認してください。工程の判定に必要な連続観測が不足する場合があります。",
    "continuityUnverified": "連続観測の完全性は保証されていません。推定工程は確定結果ではありません。",
    "otherWarning": "解析上の注意事項があります。詳しくは実行情報JSONを確認してください。",
    "queued": "受付済み",
    "collecting": "データ取得中",
    "analyzing": "計算・解析中",
    "validating": "出力検証中",
    "completed": "完了",
    "failed": "失敗",
    "canceled": "中止",
    "expired": "期限切れ",
    "text": "追加AI処理の費用条件を確認できません。設定を再取得してください。",
    "text2": "開始日時より後の終了日時を指定してください。",
    "text3": "一度に処理できる期間は最大31日です。",
    "error": "安全なダウンロードURLを取得できませんでした。",
    "all": "すべて",
    "unreviewed": "未確認",
    "truePositive": "正検知",
    "falsePositive": "誤検知",
    "text4": "{{label}}（誤検知を除く）",
    "text5": "不明な日時",
    "text6": "表示タイムゾーンが不正です",
    "text7": "検知イベント（状態変化時）",
    "text8": "連続数値観測",
    "text9": "未対応の入力データ",
    "text10": "検知開始",
    "text11": "検知終了",
    "text12": "継続中",
    "text13": "未対応の状態"
  },
  "aiAnnotationEditor": {
    "error": "画像の発生時刻を確認できません",
    "error2": "画像の原本が一致しません。出力を中止しました",
    "newAnnotation": "対象",
    "confirm": "未保存の枠の変更を破棄して閉じますか？",
    "text": "見逃し箇所の編集",
    "text2": "検知枠の編集",
    "ariaLabel": "元画像を準備中",
    "alert": "元画像を取得できません。枠は保存できません。",
    "alert2": "他の利用者が更新しました。未保存の編集を保持しています。最新の枠を読み直して再確認してください。",
    "text3": "発生時刻不明",
    "text4": "/ 保存済み revision",
    "text5": "/ AI枠: 緑、修正枠: 橙",
    "button": "枠を追加",
    "button2": "選択枠を削除",
    "button3": "元に戻す",
    "button4": "やり直し",
    "button5": "AI枠へ戻す",
    "label": "表示倍率",
    "menuItem": "倍",
    "alt": "固定元画像",
    "ariaLabel2": "検知枠編集領域",
    "ariaLabel3": "検知枠 {{label}}",
    "ariaLabel4": "枠のサイズ変更",
    "label2": "選択枠のラベル",
    "label3": "修正理由（任意）",
    "label4": "枠とラベルを確認し、学習データへ含める",
    "label5": "画像に対象がないことを確認した（負例）",
    "button6": "修正画像をダウンロード",
    "button7": "この画像の見逃しを報告",
    "button8": "修正履歴",
    "button9": "学習データを出力",
    "confirm2": "未保存の編集を破棄し、最新の枠を読み直しますか？",
    "button10": "最新の枠を読み直す",
    "button11": "枠を保存",
    "text6": "見逃しを報告",
    "text7": "この固定画像で検知すべきだった対象を入力してください。",
    "label6": "検知すべき対象",
    "button12": "報告を作成",
    "text8": "/ 修正者",
    "button13": "続きを見る",
    "text9": "このカメラの直近50件から、確定済み画像を選択してください。画像・revision・ラベルを固定して出力します。",
    "label7": "{{value}} / {{value2}} / {{value3}}",
    "label8": "学習class（1行に1つ、行順がclass番号）",
    "label9": "出力形式",
    "button14": "ZIPをダウンロード"
  },
  "aiAnnotationReportsDialog": {
    "text": "見逃し報告と画像修正",
    "label": "カメラ",
    "text2": "検知イベントがない見逃しも、カメラと発生時刻で登録できます。画像のない報告は学習データへ出力されません。",
    "label2": "発生時刻（この端末の時刻）",
    "label3": "検知すべき対象",
    "label4": "報告内容（任意）",
    "alert": "見逃し報告を登録しました。",
    "button": "見逃し報告を登録",
    "text3": "このカメラの直近50件",
    "text4": "見逃し",
    "text5": "画像修正",
    "button2": "画像と枠を開く",
    "label5": "この時刻のカメラ元画像を固定する（画像なしの場合はエラー）"
  }
}
